export const PDF_RAW_PLACEHOLDER = '/placeholder/';
export const FILE_NAME_HEADER = 'x-file-name';
